import {JSONSchema7} from "json-schema";

const ProductInfoModelSimpleTextSchema = async () => {
    let schema: JSONSchema7 = {
        title: "ProductInfoModelSimpleTextSchema",
        type: "object",
        //
        definitions: {}
    };
    //
    schema = {
        properties: {
            className: {
                type: "string",
            },
            //
            hideSKU: {
                type: "boolean",
                default: false,
            },
            hideName: {
                type: "boolean",
                default: false,
            }

        },
        //
        ...schema
    }
    //
    return schema;
}

export default ProductInfoModelSimpleTextSchema;
